import { RaceTypeAvailableSchema } from './RaceTypeAvailable.styles';

export const raceTypeAvailableStyles: RaceTypeAvailableSchema = {
  raceTypeButton: {
    variant: 'tab',
    py: '0.5',
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '2xs',
    px: '2',
    pb: '2px',
    borderRadius: 'md',
    sx: {
      '&&': {
        h: '24px',
      },
      '&[data-active="true"]': {
        bg: 'gamma.700',
        bgImg: 'none',
      },
    },
    _hover: {
      bgGradient: 'linear(to-b, beta.500, beta.600)',
    },
  },
};
